import React from "react";
import { Route, Switch, HashRouter } from "react-router-dom";
import Home from "./Components/Home";
import './css/index.css'
import Search from "./Components/Search";
import "./css/software.css";
import Footer from "./Components/Footer";
import Tutorials from "./Softwares/Tutorials";
import Sidebar from './Components/SideBar';
import Contact, {Thankyou} from './Components/Contact.js';
import Defaults from './Components/Defaults'

const App = () => {
  const [shouldRefresh, setShouldRefresh] = React.useState(false);
  React.useEffect(() => {
    const id = setTimeout(
      () => setShouldRefresh(true),
      10
    );
    return () => clearTimeout(id);
  }, []);

  return (
    <HashRouter forceRefresh={shouldRefresh}>
      <Defaults />
      <Switch>
        <Route exact path="/"><Sidebar /><Home /></Route>
        <Route exact path="/thankyou"><Sidebar /><Thankyou /></Route>
        <Route exact path="/contact"><Sidebar /><Contact /></Route>
        <Route exact path="/search/"><Search /></Route>
        <Route exact path="/search/:search"><Search /></Route>
        <Tutorials />
      </Switch>
      <Footer />
    </HashRouter>
  );
}

export default App;